import React, { useState, useEffect } from 'react';
import { Paper, Typography, Grid } from '@mui/material';
import GraficaPorHora from '../GraficaPorHora';

const campos = [
  { campo: 'eficiencia', titulo: 'Eficiencia (%)', color: 'rgba(55,167,249,1)', unidad: 'Eficiencia (%)' },
  { campo: 'acumuladoRPM', titulo: 'Acumulado RPM', color: 'rgba(249,167,55,1)', unidad: 'RPM' },
  { campo: 'amperaje', titulo: 'Amperaje (A)', color: 'rgba(55,249,167,1)', unidad: 'Amperaje (A)' },
  { campo: 'temperatura', titulo: 'Temperatura (°C)', color: 'rgba(249,55,167,1)', unidad: 'Temperatura (°C)' },
  { campo: 'humedad', titulo: 'Humedad (%)', color: 'rgba(167,55,249,1)', unidad: 'Humedad (%)' },
];

// eslint-disable-next-line react/prop-types
const MaquinaDiaGraficas = ({ fecha, maquina }) => {
  const [lecturas, setLecturas] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!fecha) return;
    setLoading(true);
    let url = `/api/eficiencia-dia-local?fecha=${fecha}`;
    if (maquina) url += `&maquina=${maquina}`;
    fetch(url)
      .then(res => res.json())
      .then(data => setLecturas(Array.isArray(data.lecturas) ? data.lecturas : []))
      .catch(() => setLecturas([]))
      .finally(() => setLoading(false));
  }, [fecha, maquina]);

  return (
    <Paper sx={{ p: 3, mt: 2, maxWidth: 1600, mx: 'auto' }}>
      <Typography variant="h4" gutterBottom align="center">Datos por Máquina Día</Typography>
      {loading ? <Typography align="center">Cargando...</Typography> : (
        <>
          {/* Primera fila: 3 gráficas */}
          <Grid container spacing={2}>
            {campos.slice(0, 3).map(({ campo, titulo, color, unidad }) => (
              <Grid item xs={12} md={4} lg={4} key={campo}>
                <GraficaPorHora
                  lecturas={lecturas}
                  campo={campo}
                  titulo={titulo}
                  color={color}
                  unidad={unidad}
                />
              </Grid>
            ))}
          </Grid>
          {/* Segunda fila: 2 gráficas centradas */}
          <Grid container spacing={2} justifyContent="center">
            <Grid item xs={false} md={2} lg={2} xl={2} />
            {campos.slice(3).map(({ campo, titulo, color, unidad }) => (
              <Grid item xs={12} md={4} lg={4} xl={4} key={campo}>
                <GraficaPorHora
                  lecturas={lecturas}
                  campo={campo}
                  titulo={titulo}
                  color={color}
                  unidad={unidad}
                />
              </Grid>
            ))}
            <Grid item xs={false} md={2} lg={2} xl={2} />
          </Grid>
        </>
      )}
    </Paper>
  );
};

export default MaquinaDiaGraficas;
